
  import echarts from 'echarts';
  import {Component, Vue} from "vue-property-decorator";
  import dataBox from "@/views/dashboard/components/dataBox.vue";
  import dataReport from "@/views/dashboard/components/dataReport.vue";
  import dataBoxSimple from "@/views/dashboard/components/dataBoxSimple.vue";
  import DataLineChart from "@/views/dashboard/components/dataLinechart.vue";
  import {getOu} from "@/utils/cookies";
  import SelectStore from "@/views/selectStore.vue";
  import {OrganizationUnitDto} from "@/api/appService";

  @Component({
    name:'DistrictDashboard',
    components:{
      SelectStore,
      dataBox,
      dataReport,
      DataLineChart,
      dataBoxSimple
    }})
  export default class DistrictDashboard extends Vue {

    get simpleParameter():any{
      return {
        orgId: this.$store.getters['user/ouId'],
        onlyMe:true,
        organizationUnitId: this.$store.getters['user/ouId']
      }
    }


    get isAllianceBusiness():boolean {
      return (this.$store.getters['user/ou'] as OrganizationUnitDto)?.isAllianceBusiness === true;
    }

    // API参数
    buildYearlyReportApiParameters(year:number, month:number):any{
      const parameters = {
        orgId: this.$store.getters['user/ouId'],
        onlyMe:true
      };
      return parameters;
    }

    buildYearlySaleReportChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'元','value');
    }

    buildYearlyNewVipCountChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'个','value');
    }
    buildYearlyRenewVipCountChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'个','value');
    }

    buildYearlyLineChartOption(res:any,unit:string,type:string):any{
      let orgList:any = []
      let data:any = []
      res.map((item:any)=>{
        orgList.push(item.orgName)
        data.push(item[type])
      });

      const option:any = {
        grid:{
          left:'30px',
          right:'0px',
          top:'10px',
          bottom:'30px',
          containLabel: true
        },
        color: ['#3398DB'],
        tooltip: {
            trigger: 'axis',
            formatter: function (params:any) {
              return `${params[0].name}:${params[0].value}${unit}`;
            },
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: {
          type: 'category',
          data: orgList
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: data,
          type: 'bar',
          barWidth: '60%',
        }]
      };
      return option;
    }


    buildTestChartOption(res:any):any{
      const data = []
      for(let i = 0;i<7;i++){
        data.push(parseInt((Math.random()*1000).toFixed()));
      }
      const option:any = {
        grid:{
          left:'30px',
          right:'0px',
          top:'10px',
          bottom:'30px'
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [123,213,213,455,67,899,554],
          name: '直接访问',
            type: 'bar',
            barWidth: '60%',
        }]
      };
      return option;
    }

  }
